import CityPageTemplate from "../city-template/CityPageTemplate";
import { fortThomasConfig } from "./data";

export default function FortThomasPage() {
  return <CityPageTemplate config={fortThomasConfig} />;
}